import React from 'react';
import Service from '../Networking/NetworkingUtils';
import { getCookie } from '../Utils/CookieHelper';
import { Toolbar, DialogActions, Tooltip, TableRow, TableCell, Dialog, AppBar, IconButton, Typography, DialogTitle, Button, DialogContent, TextField, Box, LinearProgress, ToggleButton, ToggleButtonGroup, Tabs, Tab, Autocomplete, Switch, FormControlLabel } from '@mui/material';
import moment from 'moment';
import { useSnackbar } from "notistack";
import CloseIcon from '@mui/icons-material/Close';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import UserAccess from './UserAccess';
import Slide from '@mui/material/Slide';
import DescriptionIcon from '@mui/icons-material/Description';
import Assets from './Assets';
import AssetTable from './Assets/AssetTable';
import UploadIcon from '@mui/icons-material/Upload';
// import { DropzoneArea } from 'material-ui-dropzone';
import { blobWriteString, generateRandomString } from '../Helper/BlobHelper';
import EditIcon from '@mui/icons-material/Edit';
import { useDropzone } from 'react-dropzone';
import ProgramDirectory from '../ProgramDirectory/ProgramDirectory';
import ProjectOwner from './ProjectOwner';
import InviteUser from './InviteUser';
import UserRequests from './UserRequests';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out'
};

const MAX_IMAGE_UPLOAD_SIZE = 300 * 1024;
const uploadConfig = {
  logo: {
    title: 'Upload Logo',
    folder: 'Logos',
    parentField: 'client_details',
    field: 'logo',
    successMessage: 'Logo added successfully!',
  },
  thumbnail: {
    title: 'Upload Thumbnail',
    folder: 'Thumbnails',
    field: 'project_thumbnail',
    successMessage: 'Thumbnail added successfully!',
  },
};

var token = getCookie("bb_metaverse_token");
var access = JSON.parse(getCookie("bb_metaverse_access"));
// var user = JSON.parse(getCookie('bb_metaverse_user'))

const Row = (props) => {
  const { row } = props;
  const [fulldialogopen, setFulldialogopen] = React.useState(false);
  const [editdialogopen, setEditdialogopen] = React.useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [selectedRow, setSelectedRow] = React.useState({});
  const [editProjDisable, setEditProjDisable] = React.useState(false)
  const [accessDialog, setAccessDialog] = React.useState(false)
  const [isProjSegment, setIsProjSegment] = React.useState(false)
  const [assetDialog, setAssetDialog] = React.useState(false)
  const [project, selectedProject] = React.useState(null)
  const [thumbnailUploadDialog, setThumbnailUploadDialog] = React.useState(false)
  const [uploadType, setUploadType] = React.useState('thumbnail')
  const [progress, setProgress] = React.useState(0)
  const [loading, setLoading] = React.useState(false)
  const [tabValue, setTabValue] = React.useState(0)
  const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    maxSize: MAX_IMAGE_UPLOAD_SIZE,
    accept: {
      'image/*': []
    },
  });
  const [alignment, setAlignment] = React.useState('asset');

  const files = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const rejectedFiles = fileRejections.map(({ file, errors }) => (
    <li key={file.path}>
      {file.path} - {errors.map(error => error.message).join(', ')}
    </li>
  ));

  const selectedUploadConfig = uploadConfig[uploadType];

  function Open(row) {
    if (row !== null) {
      selectedProject(row)
      setFulldialogopen(true)
    }
  }

  function Editfunc(row) {
    setSelectedRow(row)
    setEditdialogopen(true)
  }

  // function uploadData() {
  //   // setDisabled(true)
  //   towerUploadRef.current.postData()
  // }

  function handleTextChange(event) {
    setSelectedRow({ ...selectedRow, ...{ [event.target.id]: event.target.value } })
  }

  function handleActiveChange(event) {
    setSelectedRow({ ...selectedRow, is_active: event.target.checked })
  }

  function handleClientChange(selectedClient) {
    setSelectedRow((previousRow) => ({
      ...previousRow,
      client_id: selectedClient ? selectedClient.id : null,
      client_details: selectedClient,
    }))
  }

  function getSelectedClient() {
    return props.clientData?.find((client) => client.id === selectedRow?.client) || selectedRow?.client_details || null
  }

  function handleBusinessUnitChange(selectedBusinessUnit) {
    setSelectedRow((previousRow) => ({
      ...previousRow,
      business_unit_id: selectedBusinessUnit ? selectedBusinessUnit.id : null,
      business_unit: selectedBusinessUnit,
    }))
  }

  function getSelectedBusinessUnit() {
    return props.businessUnits?.find((bu) => bu.id === selectedRow?.business_unit) || selectedRow?.business_unit || null
  }

  function submitEditProject() {
    if (!selectedRow['name'] || !selectedRow['description'] || !selectedRow['client_details'] || !selectedRow['business_unit']) {
      enqueueSnackbar('Fields are not completely filled', {
        variant: 'warning'
      })
    }
    else {
      editData(selectedRow)
    }
  }

  function editData(selectedRow) {
    setEditProjDisable(true)
    Service.patch('/api/projects/edit_project/', {
      headers: {
        Authorization: "Token " + token,
      },
      data: selectedRow
    }).then(res => {
      enqueueSnackbar('Data added successfully!', {
        variant: 'success'
      })
      setEditdialogopen(false)
      setEditProjDisable(false)
      props.getProject()
    }).catch(error => {
      setEditProjDisable(false)
      console.log(error);
      enqueueSnackbar('Something went wrong!', {
        variant: 'error'
      })
    })
  }

  function UpdateProjectUpload(filePath, rowData) {
    const updatedRowData = selectedUploadConfig.parentField ? {
      ...rowData,
      [selectedUploadConfig.parentField]: {
        ...(rowData[selectedUploadConfig.parentField] || {}),
        [selectedUploadConfig.field]: filePath,
      },
    } : {
      ...rowData,
      [selectedUploadConfig.field]: filePath,
    }

    let url = ''
    let obj = {}
    if (uploadType === 'thumbnail') {
      url = '/api/projects/edit_project/'
      obj = updatedRowData
    } else {
      url = '/api/clients/edit_client_details/'
      obj = updatedRowData.client_details
    }

    Service.patch(url, {
      headers: {
        Authorization: "Token " + token,
      },
      data: obj
    }).then(res => {
      enqueueSnackbar(selectedUploadConfig.successMessage, {
        variant: 'success'
      })
      setSelectedRow(null)
      setThumbnailUploadDialog(false)
      props.getProject()
    }).catch(error => {
      console.log(error);
      enqueueSnackbar('Something went wrong!', {
        variant: 'error'
      })
    })
  }

  // const updateDisabled = (value) => {
  //   setDisabled(value)
  // }

  // const getData = () => {
  //   dataDisplayRef.current.getData()
  // }

  // const handleFailureData = (childData) => {
  //   // setFailureData(childData)
  //   // setFailureDataDialog(true)
  // }

  const handleOpen = (row) => {
    setAccessDialog(true)
    setSelectedRow(row)
    setIsProjSegment(false)
  }

  const handleAccessDialog = () => {
    setAccessDialog(false)
  }

  // const openAddLink = (row) => {
  //   // setLinkDialog(true)
  //   setProject(row)
  //   console.log(row)
  // }

  const closeAssetDialog = () => {
    setAssetDialog(false)
  }

  const handleAssetDialog = (row) => {
    setSelectedRow(row)
    setAssetDialog(true)
  }

  const handleUploadDialog = () => {
    setSelectedRow(null)
    setThumbnailUploadDialog(false)
  }

  const openUploadDialog = (row, type) => {
    setSelectedRow(row)
    setUploadType(type)
    setProgress(0)
    setThumbnailUploadDialog(true)
  }

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };



  const uploadFiles = async () => {
    const { BlobServiceClient } = require("@azure/storage-blob");
    window.Buffer = require("buffer").Buffer;

    // Use the updated blobWriteString to receive the blob write SAS URL
    let writeStringObj = uploadType === 'thumbnail' ? { token_type: 'write_only', container_name: 'project-executables' } : { token_type: 'write_only', container_name: 'client-info' };
    const blobSasUrl = await blobWriteString(writeStringObj);
    const blobServiceClient = new BlobServiceClient(blobSasUrl);

    const containerName = uploadType === 'thumbnail' ? "project-executables/BBVPROJ" + selectedRow.id + "/" + selectedUploadConfig.folder : "client-info/BBVPROJ" + selectedRow.id + "/" + selectedUploadConfig.folder;

    const containerClient = blobServiceClient.getContainerClient(containerName);

    try {
      if (acceptedFiles.length === 0) {
        enqueueSnackbar('Please select an image up to 300KB.', {
          variant: 'warning'
        });
        return;
      }

      setLoading(true)
      const file = acceptedFiles[0];
      const file_extension = file.name.split('.').pop()
      const file_name = generateRandomString() + "." + file_extension
      const blockBlobClient = containerClient.getBlockBlobClient(file_name);
      await blockBlobClient.uploadData(file, {
        onProgress: ev => {
          setProgress((ev.loadedBytes / file.size) * 100)
        }
      });
      setLoading(false)
      UpdateProjectUpload(containerName + "/" + file_name, selectedRow)
      // this.props.updateBlob(file_name_array, this.props.version)
    }
    catch (error) {
      setLoading(false)
      console.log(error.message);
      enqueueSnackbar('Something went wrong!', {
        variant: 'error'
      });
    }
  }

  return (
    <React.Fragment>
      <TableRow onClick={() => Open(row)} sx={{ cursor: 'pointer' }}>
        <TableCell component="th" scope="row" align="left" >
          {row?.name}
        </TableCell>
        <TableCell align="left">{row?.description}</TableCell>
        <TableCell align="left">{row?.client_details?.name}</TableCell>
        <TableCell align="left">{row?.business_unit_details?.name}</TableCell>
        <TableCell align="left">{moment(row?.date_created).format('DD-MM-YYYY')}</TableCell>
        <TableCell align="left">{row?.last_name}{", "}{row?.first_name}</TableCell>
        <TableCell align="left" sx={{ width: 100 }} onClick={(event) => { if (event) { event.stopPropagation(); } }}>
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            {(row?.project_admin) ||
              (access && access.access && access.access.l0a.l0a_b) ?
              <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                {/* <Tooltip title='Upload Logo'>
                  <CloudUploadIcon sx={{ cursor: "pointer" }} onClick={(event) => { event.stopPropagation(); openUploadDialog(row, 'logo') }} />
                </Tooltip> */}
                <Tooltip title="Upload Thumbnail">
                  <UploadIcon sx={{ cursor: "pointer" }} onClick={(event) => { event.stopPropagation(); openUploadDialog(row, 'thumbnail') }} />
                </Tooltip>
                <Tooltip title="Project Assets">
                  <DescriptionIcon sx={{ ml: 1, cursor: "pointer" }} onClick={(event) => { event.stopPropagation(); handleAssetDialog(row) }} />
                </Tooltip>
                <Tooltip title="Access for Users">
                  <GroupAddIcon sx={{ ml: 1, cursor: "pointer" }} onClick={(event) => { event.stopPropagation(); handleOpen(row) }} />
                </Tooltip>
                <Tooltip title="Edit Project">
                  <EditIcon onClick={() => Editfunc(row)} sx={{ fontSize: "sm", cursor: "pointer" }} />
                </Tooltip>
              </div> : null}
          </div>
        </TableCell>
      </TableRow>


      <Dialog
        fullScreen
        open={fulldialogopen}
        TransitionComponent={Transition}
      >
        <AppBar position="static">
          <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box style={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
                onClick={() => setFulldialogopen(false)}
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {project?.name}
              </Typography>
            </Box>
            <Box>
              {access && access?.access && access?.access?.l0b?.l0b_b ?
                <ToggleButtonGroup
                  color='secondary'
                  value={alignment}
                  exclusive
                  onChange={handleChange}
                >
                  <ToggleButton value="asset">Asset</ToggleButton>
                  <ToggleButton value="directory">Program Directory</ToggleButton>
                </ToggleButtonGroup>
                : null}
            </Box>
          </Toolbar>
        </AppBar>
        <DialogContent>
          {alignment === 'asset' ? <AssetTable data={project} /> : <ProgramDirectory data={project} />}
        </DialogContent>
      </Dialog>

      <Dialog maxWidth="xs" fullWidth={true} open={editdialogopen} TransitionComponent={Transition}>
        <DialogTitle>Edit Project </DialogTitle>
        <DialogContent sx={{ gap: "12px", display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: "column", }}>
          <TextField fullWidth autoComplete="off" defaultValue={selectedRow?.name} variant="outlined" label="Name" id="name" onChange={handleTextChange}></TextField>
          <TextField fullWidth autoComplete="off" defaultValue={selectedRow?.description} variant="outlined" label="Description" id="description" onChange={handleTextChange}></TextField>
          <Autocomplete
            fullWidth
            options={props.clientData ? props.clientData : []}
            value={getSelectedClient()}
            getOptionLabel={(option) => option.name || ""}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(event, selectedClient) => handleClientChange(selectedClient)}
            renderInput={(params) => <TextField {...params} label="Client" variant="outlined" />}
          />
          <Autocomplete
            fullWidth
            options={props.businessUnits ? props.businessUnits : []}
            value={getSelectedBusinessUnit()}
            getOptionLabel={(option) => option.name || ""}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(event, selectedBusinessUnit) => handleBusinessUnitChange(selectedBusinessUnit)}
            renderInput={(params) => <TextField {...params} label="Business Unit" variant="outlined" />}
          />
          <FormControlLabel
            sx={{ alignSelf: 'flex-start' }}
            label="Active"
            control={
              <Switch
                checked={selectedRow?.is_active !== false && selectedRow?.is_active !== 'False'}
                onChange={handleActiveChange}
              />
            }
          />
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => setEditdialogopen(false)}>Cancel</Button>
          <Button disabled={editProjDisable} color="primary" onClick={() => submitEditProject()}>Edit</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        maxWidth="lg"
        fullWidth={true}
        TransitionComponent={Transition}
        open={accessDialog}
        onClose={handleAccessDialog}
      >
        <Box sx={{ m: 2 }}>
          <Tabs value={tabValue} onChange={(event, newValue) => setTabValue(newValue)} centered>
            <Tab label="Project Owner" />
            <Tab label="Project User" />
            <Tab label='Invite User' />
            <Tab label='Approve User' />
            <Tab label='User Requests' />
          </Tabs>
          <Box marginTop={2}>
            {tabValue === 0 ? <ProjectOwner project={selectedRow} /> :
              tabValue === 1 ? <UserAccess project={selectedRow} isProjSegment={isProjSegment} /> :
                tabValue === 2 ? <InviteUser
                  key={tabValue}
                  getAPI={`/api/project/user/invite/get_user_invite_request/?project=${selectedRow?.id}`}
                  isInviteUser={true}
                  loading={true}
                  title={'Invite Requests'}
                  project={selectedRow} /> :
                  tabValue === 3 ? <InviteUser
                    key={tabValue}
                    getAPI={`/api/project/user/invite/get_user_invite_request/?status=0`}
                    loading={true}
                    isApproveUser={true}
                      title={'Approve Requests'} project={selectedRow} /> :
                  tabValue === 4 ? <UserRequests
                    key={tabValue}
                    title={'User Requests'}
                    project={selectedRow} /> : null}
          </Box>
        </Box>
      </Dialog>

      <Dialog
        fullScreen
        open={assetDialog}
        onClose={closeAssetDialog}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={closeAssetDialog}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Asset
            </Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{ m: 2 }}>
          <Assets row={selectedRow} />
        </Box>
      </Dialog>

      <Dialog
        maxWidth="lg"
        fullWidth={true}
        TransitionComponent={Transition}
        open={thumbnailUploadDialog}
        onClose={handleUploadDialog}>
        <DialogTitle>{selectedUploadConfig.title}</DialogTitle>
        <DialogContent>
          <section className="container">
            <div {...getRootProps({ style: baseStyle })}>
              <input {...getInputProps()} />
              <p>Drag 'n' drop an image here, or click to select one</p>
              <Typography variant="caption">Maximum file size: 300KB</Typography>
            </div>
            <aside>
              <h4>Files</h4>
              <ul>{files}</ul>
              {rejectedFiles.length > 0 ? <ul>{rejectedFiles}</ul> : null}
            </aside>
          </section>
        </DialogContent>
        <DialogActions>
          <Button color='primary' variant='contained' onClick={() => handleUploadDialog()}>
            close
          </Button>
          <Button disabled={acceptedFiles.length === 0 || loading} color='primary' variant='contained' onClick={() => uploadFiles()}>
            submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog maxWidth="lg" fullWidth={true} open={loading}  >
        <DialogTitle marginTop="2px" spacing={2}>Uploading...</DialogTitle>
        <DialogContent>
          <Box display="flex" alignItems="center">
            <Box width="100%" mr={1}>
              <LinearProgress variant="determinate" value={progress} />
            </Box>
            <Box minWidth={35}>
              <Typography variant="body2" color="primary">{`${Math.round(
                progress,
              )}%`}</Typography>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

    </React.Fragment >
  )
}

export default Row;

